import { connect } from 'react-redux';
import { ThunkDispatch } from "redux-thunk";

import {
    Action,
    deleteSlide,
    showSlideNotesDialog,
    startShapeSketching,
    startSlideDragging,
    zoomInSlide
} from '../actions';

import {
    getShapeDragging,
    getSketchMode,
    getSlideDragging, getZoomLevel,
    SketchMode,
    SlideData,
    State,
} from '../reducers';

import SlideView from "../components/SlideView";
import * as React from "react";


interface OwnProps {
    readonly slide: SlideData,
    readonly calculateSVGPoint: (mouseX: number, mouseY: number) => {x: number, y: number},
}

interface StateProps {
    readonly slide: SlideData,
    readonly dragging: boolean,
    readonly shapeDragging: boolean,
    readonly sketchMode: SketchMode,
    readonly zoomLevel: number,
    readonly calculateSVGPoint: (mouseX: number, mouseY: number) => {x: number, y: number},
    readonly stopPropagation: (e: React.MouseEvent<SVGElement>) => void,
}

interface DispatchProps {
    readonly onStartDragging: (e: React.MouseEvent<SVGElement>) => void,
    readonly onStartSketching: (e: React.MouseEvent<SVGElement>) => void,
    readonly onZoomInOrOut: (e: React.MouseEvent<SVGElement>) => void,
    readonly onDeleteButtonClicked: (e: React.MouseEvent<SVGElement>) => void,
    readonly onUpdateNotes: (e: React.MouseEvent<SVGElement>) => void,
}


function stopPropagation(e: React.MouseEvent<SVGElement>) {
    e.stopPropagation();
    e.preventDefault();
}

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const slide = ownProps.slide;
    const draggingState = getSlideDragging(state);
    const dragging = draggingState ? draggingState.uuid === slide.uuid : false;
    const shapeDragging = getShapeDragging(state) !== null;
    const sketchMode = getSketchMode(state);
    const zoomLevel = getZoomLevel(state);
    return {
        slide,
        dragging,
        shapeDragging,
        sketchMode,
        zoomLevel,
        calculateSVGPoint: ownProps.calculateSVGPoint,
        stopPropagation,
    }
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>, ownProps: OwnProps): DispatchProps => (
    {
        onStartDragging: (e) => {
            stopPropagation(e);
            const {x, y} = ownProps.calculateSVGPoint(e.clientX, e.clientY);
            dispatch(startSlideDragging(ownProps.slide.uuid, x, y));
        },
        onStartSketching: (e) => {
            stopPropagation(e);
            const {x, y} = ownProps.calculateSVGPoint(e.clientX, e.clientY);
            dispatch(startShapeSketching(ownProps.slide.uuid, x, y));
        },
        onZoomInOrOut: (e) => {
            stopPropagation(e);
            dispatch(zoomInSlide(ownProps.slide.uuid));
        },
        onDeleteButtonClicked: (e) => {
            stopPropagation(e);
            dispatch(deleteSlide(ownProps.slide.uuid));
        },
        onUpdateNotes: (e) => {
            stopPropagation(e);
            dispatch(showSlideNotesDialog(ownProps.slide.uuid, ownProps.slide.notes));
        },
    }
);


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SlideView);



// WEBPACK FOOTER //
// ./src/containers/Slide.ts